import fgInput from './components/UIComponents/Inputs/formGroupInput.vue'
import pCheckbox from './components/UIComponents/Inputs/Checkbox.vue'
import DropDown from './components/UIComponents/Dropdown.vue'
import ComboBox from './components/UIComponents/Inputs/ComboBox.vue'
import fgImage from './components/UIComponents/Inputs/formGroupImage.vue'
import VueTimepicker from 'vue2-timepicker'
import DatePicker from 'vue2-datepicker'

/**
 * You can register global components here and use them as a plugin in your main Vue instance
 */

const GlobalComponents = {
  install (Vue) {
    Vue.component('fg-input', fgInput)
    Vue.component('drop-down', DropDown)
    Vue.component('p-checkbox', pCheckbox)
    Vue.component('combo-box', ComboBox)
    Vue.component('fg-image', fgImage)
    Vue.component('vue-timepicker', VueTimepicker)
    Vue.component('date-picker', DatePicker)
  }
}

export default GlobalComponents



// WEBPACK FOOTER //
// ./src/globalComponents.js